import React, {useState, useEffect, useRef} from 'react';
import Button from 'react-bootstrap/Button';
import {showToast, toGoogleMap, commonLogDate} from '../../common/app_common.js';
import {InputAuto, BadgeChange, useBlockerWithModal} from '../../common/component_common';
import {getApiMapboxGeocoding, getApiMapboxReverseGeocoding, getApiMapboxTokenCheck} from '../../common/fetch_api/api_common.js';
import {getApiConfigLocation, postApiConfigLocation, getApiConfigSystem} from '../../common/fetch_api/configuration';
import {BsTrash, BsPlusSquare, BsSearch, BsGeoAltFill, BsChevronExpand} from 'react-icons/bs';
import * as xlsx from 'xlsx';
import {DecideWindow} from '../../common/modal_common.js';

export const View = ({existUpdate, setExistUpdate}) =>
{
    const [update, setUpdate] = useState(false);
    const [addItem, setAddItem] = useState(false);

    const [locationList, setLocationList] = useState([]);
    const [locationOrg, setLocationOrg] = useState([]);
    const [tbody, setTbody] = useState([]);

    // const mapboxToken = 'pk.eyJ1IjoiY29saW4tc291bCIsImEiOiJjbGkweHhjd2gwM293M2xvM2o1ZTFjeDF3In0.xFGD1EILl9Rx_fFQC5iGdA';
    const [mapboxToken, setMapboxToken] = useState('');
    const [name, setName] = useState('');
    const [type, setType] = useState('Callsign');
    const [coordinate, setCoordinate] = useState('');
    const [address, setAddress] = useState('');

    const [selectedCallsign, setSelectedCallsign] = useState('');
    const [callsignArray, setCallsignArray] = useState([]);

    // 기본 정렬 상태 설정
    const [sortHeader, setSortHeader] = useState('');
    const [sortOrder, setSortOrder] = useState('asc');
    
    const [modalVisible, setModalVisible] = useState(false);
    const [modalCallback, setModalCallback] = useState(null);

    const showModalDecideForRoute = ({ onConfirm }) => {
        setModalVisible(true);
        setModalCallback(() => onConfirm);
    };
    const closeModalDecideForRoute = () => {
        setModalVisible(false);
    };

    useBlockerWithModal(existUpdate, showModalDecideForRoute);

    // DecideWindow에서 OK 클릭 시
    const handleModalOk = (is) => {
        if( is )
        {
            setModalVisible(false);
            if (modalCallback) modalCallback();
        }
    };

    const SetDecideBodyMoveout = () => {
        return (
            <div className='text-center'>
                <p>There are unsaved changes. Are you sure you want to leave this page?</p>
            </div>
    )};

    function clearInputs()
    {
        setName('');
        setSelectedCallsign('');
        setType('Callsign');
        setCoordinate('');
        setAddress('');
        changeTable();
    }

    const onChangeType = (e) =>
    {
        setType(e.target.value);
    }

    const onChangeCoordinate = (e) =>
    {
        setCoordinate(e.target.value);
    }

    const onChangeAddress = (e) =>
    {
        setAddress(e.target.value);
    }

    const onClickShowInfo = (data) =>
    {
        setName(data.name);
        //InputAuto 컴포넌트 전달하기 위해
        setSelectedCallsign(data.name);
        
        setType(data.type);
        setCoordinate(`${data.latitude}, ${data.longitude}`);
        setAddress(data.address);
    }

    const onClickAddInfo = () =>
    {
        if(name && type && coordinate)
        {
            // 같은 이름이 없으면
            if(!locationList.find( x => x.name === name))
            {
                let latitude = parseFloat(coordinate.substr(0, coordinate.search(',')));
                let longitude = parseFloat(coordinate.substr(coordinate.search(',') + 1));
    
                let addData = 
                {
                    "name": name,
                    "type": type,
                    "latitude": latitude,
                    "longitude": longitude,
                    "address": address
                };

                // 새로운 데이터를 배열의 맨 앞에 추가
                const newLocationList = [addData, ...locationList];
                setLocationList(newLocationList);
                
                // callsignArray 업데이트
                const newNamesArray = [name, ...callsignArray];
                setCallsignArray(newNamesArray);

                // 테이블 직접 업데이트
                makeLocatonTbody(newLocationList);

                clearInputs();
            }
            else
            {
                showToast('Name already exists!', 'warning');
                setName('');
            }
        }
        else
        {
            showToast('Please enter all required fields!', 'warning');
        }
    }

    const onClickRemoveInfo = () =>
    {
        if(name)
        {
            let newData = locationList.filter(x => x.name !== name);
    
            setLocationList(newData);

            // callsignArray 업데이트
            const newNamesArray = newData.map(item => item.name);
            setCallsignArray(newNamesArray);

            // 테이블 직접 업데이트
            makeLocatonTbody(newData);

            clearInputs();
        }
        else
        {
            showToast('Please, Choose the Location List!', 'warning');
        }
    }

    const onClickGotoMap = () =>
    {
        if(coordinate)
        {
            let latitude = parseFloat(coordinate.substr(0, coordinate.search(',')));
            let longitude = parseFloat(coordinate.substr(coordinate.search(',') + 1));

            toGoogleMap(`${latitude}, ${longitude}`);
        }
    }

    const onClickSearchCoordinate = () =>
    {
        if(coordinate)
        {
            let latitude = parseFloat(coordinate.substr(0, coordinate.search(',')));
            let longitude = parseFloat(coordinate.substr(coordinate.search(',') + 1));

            if(mapboxToken)
            {
                Promise.resolve ( getApiMapboxReverseGeocoding(longitude, latitude, mapboxToken) )
                .then( data =>
                {
                    if(data && data.features && data.features.length)
                    {
                        setAddress(data.features[0].place_name);
                    }
                    else
                    {
                        showToast('Please, Check the Location again!', 'warning');
                    }
                });
            }
            else
            {
                showToast('Please, Check the Map Token!', 'warning');
            }
        }
        else
        {
            if(mapboxToken)
            {
                showToast('Please, Check the Location again!', 'warning');
            }
            else
            {
                showToast('Please, Check the Map Token!', 'warning');
            }
        }
    }

    const onClickSearchAddress = () =>
    {
        if(address)
        {
            if(mapboxToken)
            {
                Promise.resolve ( getApiMapboxGeocoding(address, mapboxToken) )
                .then( data =>
                {
                    if(data && data.features && data.features.length)
                    {
                        setCoordinate(`${data.features[0].geometry.coordinates[1]}, ${data.features[0].geometry.coordinates[0]}`);
                    }
                    else
                    {
                        showToast('Please, Check the Address again!', 'warning');
                    }
                });
            }
            else
            {
                showToast('Please, Check the Map Token!', 'warning');
            }
        }
        else
        {
            if(mapboxToken)
            {
                showToast('Please, Check the Address again!', 'warning');
            }
            else
            {
                showToast('Please, Check the Map Token!', 'warning');
            }
        }
    }

    const inputRef = useRef(null);

    const onClickImport = () =>
    {
        inputRef.current.click();
    }

    const onChangeFile = (e) =>
    {
        const file = e.target.files[0];
        const reader = new FileReader();
    
        reader.onload = (e) =>
        {
            const wb = xlsx.read(e.target.result);
            const sheet = wb.SheetNames;
            if(sheet.length)
            {
                const data = xlsx.utils.sheet_to_json(wb.Sheets[sheet[0]], {
                    defval: '', // 빈 셀에 대해 빈 문자열 할당
                    // raw: false // 모든 값을 문자열로 변환
                });

                // 데이터가 비어있는지 확인
                if (data.length === 0)
                {
                    showToast('File is empty', 'error');
                    return;
                }

                // 필수 컬럼 존재 여부 확인
                const requiredFields = ['name', 'type', 'latitude', 'longitude', 'address'];
                const firstItem = data[0];
                const missingFields = requiredFields.filter(field => !(field in firstItem));
                if (missingFields.length > 0) {
                    showToast('Invalid file format. Required columns: name, type, latitude, longitude, address', 'error');
                    return;
                }

                // 모든 항목 검증
                const isValid = data.every(item => {
                    // name 필드 검증 (문자열이면서 빈 값이 아니어야 함)
                    if (!item.name || typeof item.name !== 'string' || item.name.trim() === '') {
                        showToast('Name is required and must be text', 'error');
                        return false;
                    }

                    // type 값 검증
                    const validTypes = ['Callsign', 'Exciter', 'Transmission'];
                    if (!validTypes.includes(item.type)) {
                        showToast('Type must be one of: Callsign, Exciter, Transmission', 'error');
                        return false;
                    }

                    return true;
                });

                if (!isValid)
                {
                    return;
                }

                // name으로 정렬
                const sortedData = [...data].sort((a, b) => {
                    // 대소문자 구분 없이 정렬하되, 같은 문자일 경우 대문자 우선
                    const compareResult = a.name.toLowerCase().localeCompare(b.name.toLowerCase());
                    if (compareResult === 0) {
                        if (a.name === a.name.toUpperCase() && b.name !== b.name.toUpperCase())
                            return -1;
                        if (a.name !== a.name.toUpperCase() && b.name === b.name.toUpperCase())
                            return 1;
                    }
                    return compareResult;
                });

                // 정렬 상태 설정
                setSortHeader('name');
                setSortOrder('asc');

                // 데이터 설정 및 테이블 업데이트
                setLocationList(sortedData);
                
                // callsignArray 업데이트
                const namesArray = sortedData.map(item => item.name);
                setCallsignArray(namesArray);

                // 테이블 직접 업데이트
                makeLocatonTbody(sortedData);
                
                showToast('File imported successfully', 'success');

                // 파일 input 초기화, 다른 파일을 업로드 할 때 초기화 되도록
                e.target.value = '';
            }
        };
    
        reader.readAsArrayBuffer(file);
    }

    const onClickExport = () =>
    {
        if (!locationList || locationList.length === 0)
        {
            showToast('No data to export', 'warning');
            return;
        }

        const ws = xlsx.utils.json_to_sheet(locationList);
        const wb = xlsx.utils.book_new();

        let filename = commonLogDate() + '_location.csv';
        xlsx.utils.book_append_sheet(wb, ws, "Sheet1");
        xlsx.writeFile(wb, filename)
    }

    const onClickClear = () =>
    {
        setLocationList([]);
        setCallsignArray([]);
        makeLocatonTbody([]);
        clearInputs();
    }
    
    const onClickSave = () =>
    {
        Promise.resolve ( postApiConfigLocation(locationList) )
        .then( done => {
            runUpdate();
        });
    }

    const runUpdate = () => {
        setUpdate(!update);
    };

    const changeTable = () =>
    {
        setAddItem(!addItem);
    }

    const makeLocatonTbody = (data) =>
    {
        if(data && data.length > 0)
        {
            setTbody(data.map((item, i) =>
            (
                <tr key={i} onClick={() => onClickShowInfo(item)}>
                    <td title={item.name}>{item.name}</td>
                    <td title={item.type}>{item.type}</td>
                    <td title={item.latitude}>{item.latitude}</td>
                    <td title={item.longitude}>{item.longitude}</td>
                    <td className='text-start' title={item.address}>{item.address}</td>
                </tr>
            )))
        }
        else
        {
            setTbody([]);
        }
    }

    useEffect(() => {
        Promise.resolve( getApiConfigSystem() )
        .then( systemInfo =>
        {
            if( !systemInfo.map.mapboxToken )
            {
                showToast('Invalid Map Token', 'error');
                return;
            }

            Promise.resolve( getApiMapboxTokenCheck(systemInfo.map.mapboxToken) )
            .then( data => {
                if( data && data.code )
                {
                    if( data.code === 'TokenValid')
                    {
                        setMapboxToken(systemInfo.map.mapboxToken);
                    }
                    else
                    {
                        showToast(data.code, 'error');
                    }
                }
                else
                {
                    showToast('Map Token Validation Failed', 'error');
                }
            })
            .catch( e => {
                showToast('Map Token Validation Failed', 'error');
            });
        });
    }, []);

    useEffect(() =>
    {
        if (sortHeader) {  // 정렬 헤더가 있을 때만 정렬 수행
            const sortedData = sortData(locationList, sortHeader, sortOrder);
            makeLocatonTbody(sortedData);
        }
    }, [sortHeader, sortOrder, locationList]);

    useEffect(() =>
    {
        Promise.resolve( getApiConfigLocation() )
        .then( data =>
        {
            setLocationList(data);
            setLocationOrg([...data]);
            makeLocatonTbody(data);

            //autoInput 을 만들기 위해 name 만 따로 배열추가
            const namesArray = data.map(item => item.name);
            setCallsignArray(namesArray);
            
            if(data.length <= 0)
            {
                makeLocatonTbody(null);
            }
        })
    }, [update]);

    useEffect(() =>
    {
        setExistUpdate(JSON.stringify(locationList) !== JSON.stringify(locationOrg));
    }, [locationList]);

    const getSelectedName = (val) =>
    {
        setSelectedCallsign(val);
        setName(val);

        const selectedSite = locationList.filter(x => x.name === val);

        if( selectedSite.length < 1)
        return;

        onClickShowInfo(selectedSite[0]);
    }

    const onClickSort = (criteria) =>
    {
        if (sortHeader === criteria)
        {
            setSortOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
        }
        else
        {
            setSortHeader(criteria);
            setSortOrder('asc');
        }
    };

    const sortData = (data, header, order) =>
    {
        return [...data].sort((a, b) =>
        {
            const aValue = a[header];
            const bValue = b[header];
    
            // 값이 undefined 또는 null인지 확인
            if (aValue === null || aValue === undefined)
            {
                return order === 'asc' ? -1 : 1;
            }
            if (bValue === null || bValue === undefined)
            {
                return order === 'asc' ? 1 : -1;
            }
    
            if (typeof aValue === 'number' && typeof bValue === 'number')
            {
                return order === 'asc' ? aValue - bValue : bValue - aValue;
            }
            else
            {
                if (header === 'name')
                {
                    // name 필드에 대한 특별 정렬 (대소문자 구분 없이 정렬 후, 같은 문자는 대문자 우선)
                    const compareResult = aValue.toLowerCase().localeCompare(bValue.toLowerCase());
                    
                    if (compareResult === 0)
                    {
                        if (aValue === aValue.toUpperCase() && bValue !== bValue.toUpperCase())
                            return order === 'asc' ? -1 : 1;
                        if (aValue !== aValue.toUpperCase() && bValue === bValue.toUpperCase())
                            return order === 'asc' ? 1 : -1;
                    }
                    
                    return order === 'asc' ? compareResult : -compareResult;
                }
                else
                {
                    return order === 'asc' ? 
                        aValue.toString().localeCompare(bValue.toString()) : 
                        bValue.toString().localeCompare(aValue.toString());
                }
            }
        });
    };

    useEffect(() =>
    {
        const location = locationList.find(loc => loc.name === name);

        if (location)
        {
            setType(location.type);
            setCoordinate(`${location.latitude}, ${location.longitude}`);
            setAddress(location.address);
        }
        else
        {
            setType('Callsign');
            setCoordinate('');
            setAddress('');
        }
    }, [name]);

    return (
        
        <div className="tab-pane show active">
            <div className="section control-location-area">
                <div className="section-title">Location</div>
                <div className="d-flex">
                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-3 label-box">Name</div>
                    <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 ps-1">
                        <div className="location-input">
                            <InputAuto data={callsignArray} selectedVal={selectedCallsign} setSelectedVal={getSelectedName} />
                        </div>
                    </div>
                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 d-flex">
                        <Button variant='primary' className="btn btn-icon ms-2" onClick={onClickAddInfo}><BsPlusSquare/></Button>
                        <Button variant='danger' className="btn btn-icon ms-2" onClick={onClickRemoveInfo}><BsTrash/></Button>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-3 label-box">Type</div>
                    <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 ps-1">
                        <select className="form-select form-select-sm" value={type} onChange={onChangeType}>
                            <option value='Callsign'>Callsign</option>
                            <option value='Exciter'>Exciter</option>
                            <option value='Transmission'>Transmission</option>
                        </select>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-3 label-box">Location</div>
                    <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 ps-1">
                        <div className="d-flex">
                            <input className="form-control input-box" type="text" value={coordinate} onChange={onChangeCoordinate}/>
                        </div>
                    </div>
                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 d-flex">
                        <Button variant='primary' className="btn btn-icon ms-2" onClick={onClickSearchCoordinate}><BsSearch/></Button>
                        <Button variant='primary' className="btn btn-icon ms-2" onClick={onClickGotoMap}><BsGeoAltFill/></Button>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-3 label-box">Address</div>
                    <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 ps-1">
                        <input className="form-control input-box" type="text" value={address} onChange={onChangeAddress}/>
                    </div>
                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 d-flex">
                        <Button variant='primary' className="btn btn-icon ms-2" onClick={onClickSearchAddress}><BsSearch/></Button>
                    </div>
                </div>
                <hr />
                <div className="d-flex flex-wrap">
                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Location List</div>
                    <div className="col-xxl-8 col-xl-8 col-lg-8 col-md-9 col-sm-12 col-12 ps-1 mb-2">
                        <div className="location-list-table">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th className="sorting" onClick={() => {onClickSort('name')}}>Name<BsChevronExpand /></th>
                                        <th className="sorting" onClick={() => {onClickSort('type')}}>Type<BsChevronExpand /></th>
                                        <th className="sorting" onClick={() => {onClickSort('latitude')}}>Latitude<BsChevronExpand /></th>
                                        <th className="sorting" onClick={() => {onClickSort('longitude')}}>Longitude<BsChevronExpand /></th>
                                        <th className="sorting" onClick={() => {onClickSort('address')}}>Address<BsChevronExpand /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tbody}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="col-xxl-1 col-xl-1 col-lg-2 col-md-2 col-sm-2 col-2">
                        <div className="d-flex list-btns">
                            <Button variant='primary' className="btn btn-sm ms-2 mb-2" htmlFor='file' onClick={onClickImport}>Import</Button>
                            <input type="file" id='file' ref={inputRef} onChange={onChangeFile} accept=".xlsx, .xls, .csv"/>
                            <Button variant='primary' className="btn btn-sm ms-2 mb-2" onClick={onClickExport}>Export</Button>
                            <Button variant='danger' className="btn btn-sm ms-2" onClick={onClickClear}>Clear</Button>
                        </div>
                    </div>
                </div>
                <div className="d-flex my-2 ms-2">
                    <Button variant="primary" className="btn btn-sm btn-badge-change" onClick={onClickSave}>Save<BadgeChange show={existUpdate}/></Button>
                    <span className={`ms-3 mt-1 text-warning ${existUpdate?"":"d-none"}`}>There are unsaved changes. Please click the Save button to apply your changes.</span>
                </div>
            </div>
            {modalVisible&&<DecideWindow result={handleModalOk} show={modalVisible} handleClose={closeModalDecideForRoute} body={<SetDecideBodyMoveout />} okButtonTxt={'OK'}/>}
        </div>
    )
}